'use strict';

const $ = require('jquery');
require('waypoints/lib/noframework.waypoints.min.js');

const SELECTORS = {
    NAV: '.production-nav',
    BUTTON: '.production-nav__item',
};

const CLASSES = {
    BUTTON_ACTIVE: 'production-nav__item--active',
};

function init() {
    let $container = $(SELECTORS.NAV);

    if (!$container.length) {
        return false;
    }

    (function () {
        new Waypoint({
          element: document.getElementById('trigger'),
          handler: function(direction) {
            if (direction === 'down') {
                document.getElementById('nav').classList.add('is-sticky');
            } else {
                document.getElementById('nav').classList.remove('is-sticky');
            }
          }
        })
    })();

    $(document).on('scroll', () => {
        let scrollPos = $(document).scrollTop() + $container.height();

        $(SELECTORS.BUTTON).each(function () {
            let $this = $(this);
            let $target = $($this.data('target'));
            let targetTop = $target.position().top;

            if (targetTop <= scrollPos && targetTop + $target.height() > scrollPos) {
                $(SELECTORS.BUTTON).removeClass(CLASSES.BUTTON_ACTIVE);
                $this.addClass(CLASSES.BUTTON_ACTIVE);
            } else {
                $this.removeClass(CLASSES.BUTTON_ACTIVE);
            }
        });
    });

    const productionNavWrapper = document.querySelector('.production-nav__wrapper');
    productionNavWrapper.scrollLeft = 0;

    let pos = { left: 0, x: 0 };
    let isDragging = false;

    const mouseDownHandler = function(e) {
        pos = {
            left: productionNavWrapper.scrollLeft,
            x: e.clientX,
        };

        productionNavWrapper.style.cursor = 'grabbing';
        productionNavWrapper.style.userSelect = 'none';

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = function(e) {
        const dx = e.clientX - pos.x;

        if (dx !== 0) {
            isDragging = true;
        }

        productionNavWrapper.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function() {
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);

        productionNavWrapper.style.cursor = 'grab';
        productionNavWrapper.style.removeProperty('user-select');

        if (isDragging) {
            document.addEventListener('click', preventClickHandler, true);
        }

        isDragging = false;
    };

    const preventClickHandler = function(event) {
        event.stopPropagation();
        event.preventDefault();
        document.removeEventListener('click', preventClickHandler, true);
    };

    productionNavWrapper.addEventListener('mousedown', mouseDownHandler);

}

module.exports = {
    init: init
};
